import React, { FC } from 'react';
import { CapTableVersion } from 'common/types/company';
import { SelectValueViewer } from 'components';

interface CapTableSelectionValueViewerProps {
  capTableVersions?: CapTableVersion[];
  [key: string]: any;
}

/**
 * Value viewer for captable selection cells in the equity allocation spreadsheet.
 * When capTableVersions are provided (child/holding company context), resolves the
 * captable name from those versions using useAliasList=false, rather than reading
 * from the global store which only holds the parent company's captables.
 */
const CapTableSelectionValueViewer: FC<CapTableSelectionValueViewerProps> = ({ capTableVersions, ...props }) => {
  if (capTableVersions?.length) {
    return (
      <SelectValueViewer
        {...props}
        options={capTableVersions}
        useAliasList={false}
        useLabel={false}
      />
    );
  }

  return <SelectValueViewer {...props} useAliasList useLabel={false} />;
};

export default CapTableSelectionValueViewer;
